var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-6 container-background", attrs: { fluid: "" } },
    [
      _c("v-card", { staticClass: "main-card pa-6 mb-6" }, [
        _c(
          "div",
          {
            staticClass: "d-flex align-center justify-space-between flex-wrap",
          },
          [
            _c("div", [
              _c(
                "h1",
                { staticClass: "main-title" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "rgb(204 33 40)" } },
                    [_vm._v(" mdi-form-select ")]
                  ),
                  _vm._v(" Configuración de campos "),
                ],
                1
              ),
              _c("p", { staticClass: "main-subtitle" }, [
                _vm._v(
                  " Personaliza los campos del formulario configurando su nombre, visibilidad y obligatoriedad. Si no se define una configuración, el sistema conservará el nombre original y los campos serán opcionales. "
                ),
              ]),
            ]),
          ]
        ),
      ]),
      _vm.items.length == 0
        ? _c("v-card", { staticClass: "info-card pa-5 mb-6" }, [
            _c(
              "div",
              { staticClass: "d-flex align-start" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-3 mt-1",
                    attrs: { color: "rgb(204 33 40)" },
                  },
                  [_vm._v(" mdi-information-outline ")]
                ),
                _c("div", [
                  _c("div", { staticClass: "info-title" }, [
                    _vm._v(" Configuración inteligente de campos "),
                  ]),
                  _c("div", { staticClass: "info-text" }, [
                    _vm._v(
                      " Realice la configuración inicial del formulario para poder utilizar las funcionalidades de este módulo. "
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "v-row",
        _vm._l(_vm.items, function (item) {
          return _c(
            "v-col",
            { key: item.key, attrs: { cols: "12", md: "6", lg: "6" } },
            [
              _c(
                "v-card",
                { staticClass: "field-card pa-5" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center justify-space-between mb-4",
                    },
                    [
                      _c("div", { staticClass: "field-name" }, [
                        _vm._v(" " + _vm._s(item.description) + " "),
                      ]),
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            small: "",
                            color: item.mandatory
                              ? "red lighten-5"
                              : "blue lighten-5",
                            "text-color": item.mandatory
                              ? "red darken-2"
                              : "blue darken-2",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.mandatory ? "Obligatorio" : "Configurable"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("label", { staticClass: "custom-label" }, [
                    _vm._v(" Nombre a mostrar "),
                  ]),
                  _c("v-text-field", {
                    staticClass: "custom-input",
                    attrs: {
                      outlined: "",
                      dense: "",
                      placeholder: "Ingrese un alias",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "grey",
                                                    },
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " mdi-information-outline "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " Personaliza el nombre que verá el cliente. "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: item.alias,
                      callback: function ($$v) {
                        _vm.$set(item, "alias", $$v)
                      },
                      expression: "item.alias",
                    },
                  }),
                  !item.mandatory
                    ? _c(
                        "div",
                        [
                          _c("label", { staticClass: "custom-label" }, [
                            _vm._v(" Nivel de exigencia "),
                          ]),
                          _c("v-select", {
                            staticClass: "custom-input",
                            attrs: {
                              items: _vm.requiredOptions,
                              "item-text": "name",
                              "item-value": "value",
                              outlined: "",
                              dense: "",
                              "prepend-inner-icon": "mdi-file-check-outline",
                              disabled: _vm.isRequiredDisabled(item),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onRequiredChange(item, $event)
                              },
                            },
                            model: {
                              value: item.required,
                              callback: function ($$v) {
                                _vm.$set(item, "required", $$v)
                              },
                              expression: "item.required",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  !item.mandatory
                    ? _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c("label", { staticClass: "custom-label" }, [
                            _vm._v(" Estado de visualización "),
                          ]),
                          _c("v-select", {
                            staticClass: "custom-input",
                            attrs: {
                              items: _vm.visibleOptions,
                              "item-text": "name",
                              "item-value": "value",
                              outlined: "",
                              dense: "",
                              "prepend-inner-icon": "mdi-eye-outline",
                              disabled: _vm.isVisibleDisabled(item),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onVisibleChange(item, $event)
                              },
                            },
                            model: {
                              value: item.visible,
                              callback: function ($$v) {
                                _vm.$set(item, "visible", $$v)
                              },
                              expression: "item.visible",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "status-container mt-4" }, [
                    _c(
                      "div",
                      { staticClass: "status-item" },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              small: "",
                              color: item.visible ? "green" : "grey",
                            },
                          },
                          [_vm._v(" mdi-circle ")]
                        ),
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(item.visible ? "Visible" : "Oculto") +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "status-item" },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              small: "",
                              color: item.required ? "orange" : "grey",
                            },
                          },
                          [_vm._v(" mdi-alert-circle ")]
                        ),
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(item.required ? "Requerido" : "Opcional") +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "8", md: "6" } },
            [
              _vm.showAlert
                ? _c(
                    "v-alert",
                    {
                      staticClass: "my-4",
                      attrs: {
                        type: _vm.alertType,
                        border: "left",
                        "colored-border": "",
                        elevation: "2",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-end mt-4" },
        [
          _c(
            "v-btn",
            {
              staticClass: "white--text px-10 font-weight-bold",
              attrs: {
                color: "rgb(204 33 40)",
                "x-large": "",
                elevation: "2",
                rounded: "",
              },
              on: { click: _vm.save },
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [
                _vm._v(" mdi-content-save-outline "),
              ]),
              _vm._v(" Guardar configuración "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.6", "z-index": "9999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "rgb(204 33 40)" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }